export const ls = {
	NAMESPACE: '__db_ls__',
	_keys: {},
	_addKey: function(key) {
		this._keys[key] = key;
	},
	_getKey: function(key) {
		return `${this.NAMESPACE}${key}`;
	},
	_removeKey: function(key) {
		delete this._keys[key];
	},
	setItem: function(key, value, expire) {
		const _value = {
			data: value,
			time: Date.now(),
			expire: expire
		};
		this._addKey(key);
		localStorage.setItem(this._getKey(key), JSON.stringify(_value));
	},
	getItem: function(key) {
		let val = localStorage.getItem(this._getKey(key));
		if (!val) {
			return val;
		}
		val = JSON.parse(val);
		if (Date.now() - val.time > val.expire) {
			this.removeItem(key);
			return null;
		}
		return val.data;
	},
	removeItem: function(key) {
		this._removeKey(key);
		localStorage.removeItem(this._getKey(key));
	},
	clear: function() {
		Object.keys(this._keys).map(key => {
			this.removeItem(key);
		});
	}
};
